import { PaymentsSummaryList, DriverPaymentsSummaryList } from "../../api";
import * as ReduxToolkit from "@reduxjs/toolkit";
import { JST } from "../../utils/time";
import dayjs from "dayjs";

export interface PaymentsSummaryInputState {
    start_month: string;
    end_month: string;
}

export interface State {
    paymentsSummary?: PaymentsSummaryList | null;
    paymentsSummaryInput: PaymentsSummaryInputState;
    paymentByDriverSummary?: DriverPaymentsSummaryList | null;
    selectedMonth?: string;
}

export function initState(): State {
    const this_month = dayjs().tz(JST).format("YYYY/MM");
    const start_month = dayjs().tz(JST).add(-1, "M").format("YYYY/MM");
    return {
        paymentsSummaryInput: {
            start_month: start_month,
            end_month: this_month,
        },
        selectedMonth: this_month,
    };
}

export const paymentsSlice = ReduxToolkit.createSlice({
    name: "payments",
    initialState: initState(),
    reducers: {
        resetState: (state) => {
            state = initState();
            return state;
        },
        update_selected_month: (
            state,
            action: ReduxToolkit.PayloadAction<string>
        ) => {
            state.selectedMonth = action.payload;
            return state;
        },
        update_payments_summary_input: (
            state,
            action: ReduxToolkit.PayloadAction<PaymentsSummaryInputState>
        ) => {
            state.paymentsSummaryInput = action.payload;
            return state;
        },
        update_payments_summary: (
            state,
            action: ReduxToolkit.PayloadAction<PaymentsSummaryList | null>
        ) => {
            state.paymentsSummary = action.payload;
            return state;
        },
        update_payments_by_driver: (
            state,
            action: ReduxToolkit.PayloadAction<DriverPaymentsSummaryList | null>
        ) => {
            state.paymentByDriverSummary = action.payload;
            return state;
        },
    },
});
